import { render, staticRenderFns } from "./Sentinel.vue?vue&type=template&id=5d513d9c&"
import script from "./Sentinel.vue?vue&type=script&lang=js&"
export * from "./Sentinel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports